<div mat-dialog-content>
    @if (!blueprintExists) {
        <p>{{ 'blueprintList.inputName.title' | translate }}</p>
        <input matInput type="text" class="form-control" [(ngModel)]="currentName" [disabled]="disabled"/>
        <app-button
            [buttonType]="'primary'"
            [label]="'blueprintList.inputName.buttons.validate' | translate"
            (clickEmitter)="validateName()"
            [disabled]="disabled"
        ></app-button>
    } @else {
        @if (blueprintHasDraft) {
            <p>{{ 'blueprintList.inputName.hasDraft' | translate : {name: currentName} }}</p>
            <div class="button-container">
                <app-button
                    [buttonType]="'secondary'"
                    [label]="'blueprintList.inputName.buttons.retry' | translate"
                    (clickEmitter)="retry()"
                ></app-button>
                <app-button
                    [buttonType]="'primary'"
                    [label]="'blueprintList.inputName.buttons.edit' | translate"
                    (clickEmitter)="edit()"
                ></app-button>
            </div>
        } @else {
            <p>{{ 'blueprintList.inputName.alreadyExists' | translate : {name: currentName} }}</p>
            <div class="button-container">
                <app-button
                    [buttonType]="'secondary'"
                    [label]="'blueprintList.inputName.buttons.retry' | translate"
                    (clickEmitter)="retry()"
                ></app-button>
                <app-button
                    [buttonType]="'primary'"
                    [label]="'blueprintList.inputName.buttons.copy' | translate"
                    (clickEmitter)="copy()"
                ></app-button>
            </div>
        }
    }
</div>
